import { useEffect, useState } from "react";
import autopartsApi from "@/api/autoparts";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "@/components/icons";
import { FLOATING_LAUNCHER_CLASS, FLOATING_LAUNCHER_ICON_CLASS, FLOATING_LAUNCHER_STACK } from "@/components/floating-launcher";
import { useDraggableFloating } from "@/hooks/use-draggable-floating";
import { AdminSupport } from "@/pages/shared/support-chat";

export function AdminFloatingSupport() {
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    let mounted = true;
    const refresh = async () => {
      try {
        const conversations = await autopartsApi.shopConversations.listForSeller("sparelynk-admin-support", { forceRefresh: true });
        if (mounted) setUnread(conversations.reduce((count, thread) => count + (thread.unseenCount || 0), 0));
      } catch { /* the support inbox handles connection errors */ }
    };
    void refresh();
    const unsubscribe = autopartsApi.shopConversations.subscribe({
      participantId: "sparelynk-admin-support", role: "seller", onEvent: () => void refresh(),
    });
    const poll = window.setInterval(() => void refresh(), 15000);
    return () => { mounted = false; unsubscribe(); window.clearInterval(poll); };
  }, []);
  const launcher = useDraggableFloating("sparelynk-admin-messages-position", { id: "messages", stackIndex: FLOATING_LAUNCHER_STACK.messages });
  return <>
    <Button ref={launcher.ref} type="button" size="icon" data-dragging={launcher.isDragging} className={FLOATING_LAUNCHER_CLASS} style={launcher.style} {...launcher.dragHandlers} aria-label="Open support inbox" onClick={() => setOpen(true)}><MessageCircle className={FLOATING_LAUNCHER_ICON_CLASS} />{unread > 0 && <span className="absolute -right-1 -top-1 rounded-full bg-destructive px-1.5 py-0.5 text-[10px] font-semibold text-destructive-foreground">{unread > 99 ? "99+" : unread}</span>}</Button>
    <Sheet open={open} onOpenChange={setOpen}><SheetContent side="right" className="h-dvh w-full max-w-none overflow-hidden p-0 sm:w-[min(680px,calc(100vw_-_1rem))] sm:max-w-[680px] [&_button]:cursor-pointer"><div className="h-full overflow-auto"><AdminSupport compact /></div></SheetContent></Sheet>
  </>;
}
